export const ACCEPT_TERMS_TRANSLATION_KEY = 'acceptTerms';
export const TERMS_AGREEMENT_MESSAGE = 'terms_agreement_message';
export const TERMS_AGREEMENT_AMAZON_ADVERTISING_AGREEMENT_LINK_TEXT =
  'terms_agreement_amazon_advertising_agreement_link_text';
export const TERMS_AGREEMENT_DSP_ADVERTISING_AGREEMENT_LINK_TEXT =
  'terms_agreement_dsp_advertising_agreement_link_text';
